import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b77dedc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rolemanagement" }
const _hoisted_2 = { class: "rolemanagement_box" }
const _hoisted_3 = { style: {"padding":"50px 0"} }
const _hoisted_4 = { style: {"padding":"50px"} }

import { api_cw_add_account, api_index_get_account_list, api_cw_del_account } from '@/api/home'
import { Rule } from "ant-design-vue/es/form";
import { ref, reactive, onMounted } from "vue";

import { message, type TableColumnsType } from 'ant-design-vue';

import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();

let user = JSON.parse(store.state.user);

let FormData = reactive({
    mobile: '',
    pwd: '',
    roule: '1',
    openid: user.openid
});



onMounted(() => {
    finishFun('');
})


const rules: Record<string, Rule[]> = {
    mobile: [{ required: true, pattern: /^1[34578]\d{9}$/, message: '请确认手机号格', trigger: 'change' }],
    pwd: [{ required: true, message: '请输入密码', trigger: 'change', },
    { whitespace: true, required: true, message: '密码中不能带有空格！！' }]
};









let list: any = ref([]);
let total: any = ref(1)
//获取管理员列表
const finishFun = async (value: any) => {
    list.value = [];
    let up = {
        openid: user.openid,
        pageNo: current.value
    }
    let data: any = await api_index_get_account_list(up);
    if (data.error !== 0) {
        message.error('暂无数据！！！')
        return
    }
    total.value = data.total * 1;
    data.list.forEach((item: any) => {
        list.value.push(item);
    });

}


let current = ref<number>(1)

const paginationChange = (e: number) => {
    current.value = e;
    finishFun('');
}


const columns: TableColumnsType = [
    { title: '手机号', width: 100, dataIndex: 'mobile' },
    { title: '职权', width: 100, dataIndex: 'roule_name' },
    { title: '操作', width: 100, dataIndex: 'Controls' }
];

//新增|编辑  管理员
const onFinish = async (id: any) => {
    let up = {}
    if (!id) {
        up = {
            mobile: FormData.mobile,
            pwd: FormData.pwd,
            roule: FormData.roule,
            openid: user.openid,
        }
    } else {
        up = {
            pwd: Editing.value.pwd,
            mobile: Editing.value.mobile,
            roule: Editing.value.roule,
            openid: user.openid,
            id
        }
    }

    let data: any = await api_cw_add_account(up);
    if (data.error === 0) {
        finishFun('');
    }
    if (id) {
        EditingOpen.value = false;
    }
    FormData.mobile = '';
    FormData.pwd = '';
    FormData.roule = '1';
};



//删除管理员
const RemoveAnAdministrator = async (id: string) => {
    let up = {
        openid: user.openid,
        id
    }
    let data: any = await api_cw_del_account(up);
    console.log(data);
    DeleteOpen.value = false;
    if (data.error === 0) {
        finishFun('');
    }

}

let Delete = ref<any>(null);
let DeleteOpen = ref<boolean>(false);
//打开删除
const DeleteFun = (e: any) => {
    Delete.value = null;
    DeleteOpen.value = true;
    Delete.value = e;
}

let Editing = ref<any>(null);
let EditingOpen = ref<boolean>(false);
//编辑
const EditingFun = (e: any) => {
    EditingOpen.value = true;
    console.log(e);
    Editing.value = e;
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { style: {"width":"100%","height":"100%"} }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _unref(FormData),
          layout: "inline",
          onFinish: _cache[3] || (_cache[3] = ($event: any) => (onFinish('')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: "mobile",
              label: "手机号",
              rules: rules.mobile
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _unref(FormData).mobile,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(FormData).mobile) = $event)),
                  placeholder: "请输入手机号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, {
              name: "pwd",
              label: "密码",
              rules: rules.pwd
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _unref(FormData).pwd,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(FormData).pwd) = $event)),
                  placeholder: "请输入密码"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, { label: "权限" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _unref(FormData).roule,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(FormData).roule) = $event)),
                  style: {"width":"150px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, {
                      value: "0",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("超级管理员")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("制单员")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "3" }, {
                      default: _withCtx(() => [
                        _createTextVNode("审核员")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "4" }, {
                      default: _withCtx(() => [
                        _createTextVNode("审查员")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  "html-type": "submit",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("注册子账号")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_table, {
            class: "components-table-demo-nested",
            columns: columns,
            "data-source": _unref(list),
            scroll: { y: 500 },
            pagination: false
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'Controls')
                ? (_openBlock(), _createBlock(_component_a_space, {
                    key: 0,
                    warp: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: ($event: any) => (EditingFun(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        danger: "",
                        onClick: ($event: any) => (DeleteFun(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data-source"])
        ]),
        _createVNode(_component_a_pagination, {
          style: {"margin-top":"20px"},
          current: _unref(current),
          "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => (_isRef(current) ? (current).value = $event : current = $event)),
          simple: "",
          total: _unref(total),
          onChange: paginationChange,
          pageSize: 10,
          hideOnSinglePage: false
        }, null, 8, ["current", "total"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: "确认删除该管理员吗",
      open: _unref(DeleteOpen),
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => (_isRef(DeleteOpen) ? (DeleteOpen).value = $event : DeleteOpen = $event)),
      onOk: _cache[6] || (_cache[6] = ($event: any) => (RemoveAnAdministrator(_unref(Delete).id))),
      okText: "确认",
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_descriptions, { column: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions_item, { label: "管理员手机号" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(Delete).mobile), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "管理员职权" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(Delete).roule_name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      title: "编辑管理员",
      width: "50%",
      open: _unref(EditingOpen),
      "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => (_isRef(EditingOpen) ? (EditingOpen).value = $event : EditingOpen = $event)),
      onOk: _cache[11] || (_cache[11] = ($event: any) => (onFinish(_unref(Editing).id))),
      okText: "确认",
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_form, {
            model: _unref(Editing),
            layout: "inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "mobile",
                label: "手机号",
                rules: rules.mobile
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _unref(Editing).mobile,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(Editing).mobile) = $event)),
                    placeholder: "请输入手机号"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_component_a_form_item, {
                name: "pwd",
                label: "密码"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _unref(Editing).pwd,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(Editing).pwd) = $event)),
                    placeholder: "请输入密码"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "权限" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    ref: "select",
                    value: _unref(Editing).roule,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(Editing).roule) = $event)),
                    style: {"width":"150px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, {
                        value: "0",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("超级管理员")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "1" }, {
                        default: _withCtx(() => [
                          _createTextVNode("制单员")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "3" }, {
                        default: _withCtx(() => [
                          _createTextVNode("审核员")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "4" }, {
                        default: _withCtx(() => [
                          _createTextVNode("审查员")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})